import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { PricingTypeSelector } from "./PricingTypeSelector"
import { PricingTable } from "./PricingTable"
import { Button, Flex } from "antd"
import { Icon } from "ui/Icon"
import { spacings } from "themes/variables"
import { generateUUID } from "components/trips/utils"
import { PRICING_TYPES } from "../utils/constants"
import { FullPayment } from "./FullPayment"
import { Deposit } from "./Deposit"
import { useDispatch, useSelector } from "react-redux"
import { errorFieldsSelector } from "modules/errors/selectors"
import { CustomInputError } from "ui/CustomInputError"
import { receiveErrors } from "modules/errors/reducer"

export const LengthAndRates = ({ form }) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const [pricingType, setPricingType] = useState(form.getFieldValue("pricing_type"))
  const [expandedRowData, setExpandedRowData] = useState({})

  const [draftPrices, setDraftPrices] = useState([])

  const addNewPrice = () => {
    setDraftPrices((prev) => [...prev, { id: generateUUID() }])
    setExpandedRowData({})
    dispatch(
      receiveErrors({
        data: { message: { listing_media: [] } },
        showToast: false
      })
    )
  }

  const errors = useSelector(errorFieldsSelector())

  return (
    <Card title={t("experiences.scheduling.sections.length_and_rates.title")} className="mb-3xl">
      <Flex vertical gap={spacings.XL}>
        <Flex align="center" justify="space-between" className="gap-3 lengthRatewrapper flex-wrap">
          <PricingTypeSelector value={pricingType} setPricingType={setPricingType} form={form} />
          <Button color="primary" variant="solid" size="large" onClick={addNewPrice}>
            <Icon type="feather" name="Plus" color="currentColor" />
            {t("experiences.scheduling.sections.length_and_rates.add_new")}
          </Button>
        </Flex>
        <PricingTable
          draftPrices={draftPrices}
          setDraftPrices={setDraftPrices}
          addNewPrice={addNewPrice}
          setExpandedRowData={setExpandedRowData}
          expandedRowData={expandedRowData}
          setPricingType={setPricingType}
          pricingType={pricingType}
          form={form}
          isFlatRate={pricingType === PRICING_TYPES.FLAT_RATE}
        />
        <Button color="primary" variant="link" size="large" className="p-0 mr-auto" onClick={addNewPrice}>
          <Icon type="feather" name="Plus" color="currentColor" />
          {t("experiences.scheduling.sections.length_and_rates.add_new")}
        </Button>
        {errors.listing_rates && <CustomInputError errorKey={errors.listing_rates[0]} />}
        <FullPayment />
        <Deposit form={form} />
      </Flex>
    </Card>
  )
}
